export default __webpack_public_path__ + "static/images/checkout-4dc5f3e369d0634d751028b11abf4e44.png";